module.exports = __webpack_public_path__ + "static/img/Richard-Penisini.a9ccf16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Richard-Penisini.jpg
// module id = Eh5a
// module chunks = 0